import { AdvanceTable } from '@aibees/shared/features';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(AdvanceTable)`
  gap: ${(p) => p.theme.spacing(1)};

  .simplebar-track {
    background: transparent;
  }

  thead {
    background-color: ${(p) => p.theme.palette.grey[100]};
    height: ${(p) => p.theme.spacing(4)};
    tr {
      th {
        padding: 0;
        padding-left: ${(p) => p.theme.spacing(1.5)};
      }
      th:first-of-type {
        padding: 0;
      }
    }
  }

  tbody {
    td {
      padding: ${(p) => p.theme.spacing(0, 1.5)};
      height: ${(p) => p.theme.spacing(7)};
      &:hover {
        background: ${(p) => p.theme.palette.grey[200]};
        .QuickView,
        .last-records-update {
          display: flex;
        }
      }
    }
    tr {
      &:hover {
        background: ${(p) => p.theme.palette.grey[100]};

        td {
          background: ${(p) => p.theme.palette.grey[100]};
        }
      }
    }
  }

  &.isChartView {
    &.AdvanceTable {
      display: none;
    }
  }
  .simplebar-horizontal {
    bottom: 0 !important;
  }
`;
